import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problemarrow() {
  return (
    <section className="problem_arrow p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/arrow/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={448}
              height={638}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2 style={{ color: "#095237" }}>The Problem</h2>
            <p>
              Catalytic converters are not a common commodity and people who own
              it know that the niche nature of their product makes it difficult
              for them to sell or buy them easily when the requirement arises.
            </p>
            <p>
              People did have ebay and other similar marketplace platforms
              through which they could intend to trade in catalytic converters,
              but since this product has it’s own vagaries, such non-custom
              marketplaces didn’t serve the purpose right.
            </p>
            <p>
              This problem had been around for way too long and required a
              custom, integrated solution to get through and that’s exactly what
              Tekrevol did with the assistance of it’s client.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problemarrow;
